import './Switch.css.proxy.js';
/* src/components/Switch.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_element,
	claim_space,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	safe_not_equal,
	space
} from "../web_modules/svelte/internal.js";

import { createEventDispatcher } from "../web_modules/svelte.js";

function create_fragment(ctx) {
	let label;
	let input;
	let t;
	let span;
	let mounted;
	let dispose;

	return {
		c() {
			label = element("label");
			input = element("input");
			t = space();
			span = element("span");
			this.h();
		},
		l(nodes) {
			label = claim_element(nodes, "LABEL", { class: true });
			var label_nodes = children(label);
			input = claim_element(label_nodes, "INPUT", { type: true, class: true });
			t = claim_space(label_nodes);
			span = claim_element(label_nodes, "SPAN", { class: true });
			children(span).forEach(detach);
			label_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(input, "type", "checkbox");
			attr(input, "class", "svelte-bdmbz9");
			attr(span, "class", "slider svelte-bdmbz9");
			attr(label, "class", "switch svelte-bdmbz9");
		},
		m(target, anchor) {
			insert(target, label, anchor);
			append(label, input);
			input.checked = /*toggled*/ ctx[0];
			append(label, t);
			append(label, span);

			if (!mounted) {
				dispose = listen(input, "change", /*input_change_handler*/ ctx[1]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*toggled*/ 1) {
				input.checked = /*toggled*/ ctx[0];
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(label);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let toggled = false;
	const dispatch = createEventDispatcher();

	const toggle = () => {
		dispatch("toggled", { toggled: !toggled });
	};

	function input_change_handler() {
		toggled = this.checked;
		$$invalidate(0, toggled);
	}

	return [toggled, input_change_handler];
}

class Switch extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Switch;
//# sourceMappingURL=Switch.js.map
